import type * as React from 'react';

import { type IconDefinition, renderIcon } from '../util';

export function CardTop(props: { children: React.ReactNode }) {
    return <div {...props} className="mb-2 flex" />;
}

export function CardSurtitle(props: { children: React.ReactNode }) {
    return <div {...props} className="text-muted text-ui-small" />;
}

export function CardHeadingIcon(props: { children: IconDefinition }) {
    return renderIcon(props.children, { size: 16, className: 'm-nudge-icon shrink-0' });
}
